"use strict";
/**
 * The staff list (workflow review 2026-10-29, section A; ADR 0074). HR uploads the HR
 * system's staff sheet; it says who reports to whom, so "Who is being replaced?" on a
 * hire request lists only the requester's own team. A new upload replaces the list:
 * people missing from it are taken off (kept for history, never deleted).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_STAFF_COLUMNS = exports.STAFF_COLUMN_LABELS = exports.STAFF_COLUMNS = void 0;
exports.matchStaffColumns = matchStaffColumns;
/** The columns the sheet must have, matched by name whatever the case or spacing. */
exports.STAFF_COLUMNS = {
    name: ['name', 'full name', 'employee name'],
    email: ['email', 'email address', 'work email'],
    jobTitle: ['job title', 'title', 'designation', 'position'],
    team: ['team', 'department', 'dept'],
    managerEmail: ['manager email', 'line manager email', 'reports to email', 'manager'],
};
exports.STAFF_COLUMN_LABELS = {
    name: 'Name',
    email: 'Email',
    jobTitle: 'Job title',
    team: 'Team',
    managerEmail: 'Manager email',
};
/** Finds a sheet column for each staff field by its name. */
function matchStaffColumns(headers) {
    const normal = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ');
    const found = {};
    for (const column of Object.keys(exports.STAFF_COLUMNS)) {
        const names = exports.STAFF_COLUMNS[column];
        const header = headers.find((candidate) => names.includes(normal(candidate)));
        if (header)
            found[column] = header;
    }
    return found;
}
/** The columns an upload cannot do without. Team and job title may be blank. */
exports.REQUIRED_STAFF_COLUMNS = ['name', 'email', 'managerEmail'];
//# sourceMappingURL=staff.js.map